import React from 'react';
import SerivceBox from './cp/serviceBox';
import { CanView } from '../../utils/checkRoles';


function HomePage(props){
    return(
        <div className="d-flex flex-wrap justify-content-center">
            <SerivceBox title="نهار" linkto="/foods/program" imgSource={require('../../assets/img/pack/food.png')} />
            <CanView role={2}>
                <SerivceBox title="کاربران" linkto="/users" imgSource={require('../../assets/img/pack/user.png')} />
            </CanView>
        </div>
    )
}

export default HomePage;